import SupervisorPartTable from "./SupervisorPartTable";
export default SupervisorPartTable;
